import React, { useEffect, useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const FAQ = () => {
  const { language } = useLanguage();
  const content = weddingData[language].faq;
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen pt-24 pb-20 bg-ivory">
      {/* Header - Pastel Luxe */}
      <section className="bg-gradient-to-br from-lilac-100 via-lilac-200 to-lilac-100 py-32 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-64 h-64 bg-gold-200 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-20 right-20 w-64 h-64 bg-lilac-200 rounded-full filter blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        </div>

        <div className={`container mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <HelpCircle className="mx-auto text-gold-500 mb-8" size={64} />
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-playfair font-bold text-plum-900 mb-6">
            {content.title}
          </h1>
          <p className="text-xl text-plum-800 font-montserrat max-w-3xl mx-auto">
            {content.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent mx-auto rounded-full mt-8" />
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-20 bg-ivory">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto space-y-4">
            {content.questions.map((item, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-soft border border-lilac-100 overflow-hidden transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-lilac-50 transition-colors duration-300"
                >
                  <h3 className="text-lg font-playfair font-bold text-plum-900 pr-4">
                    {item.question}
                  </h3>
                  <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${openIndex === index ? 'bg-gold-500 text-white' : 'bg-lilac-100 text-plum-700'}`}>
                    {openIndex === index ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </div>
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-500 ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <div className="px-8 pb-6 pt-2">
                    <div className="w-full h-px bg-gradient-to-r from-transparent via-lilac-200 to-transparent mb-4" />
                    <p className="text-plum-800 font-montserrat leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-gradient-to-br from-lilac-50 to-ivory">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <Mail className="mx-auto text-gold-500 mb-6" size={48} />
            <h3 className="text-3xl font-playfair font-bold text-plum-900 mb-6">
              {language === 'fr' ? 'Vous avez d\'autres questions ?' : 'Have more questions?'}
            </h3>
            <p className="text-lg text-plum-800 font-montserrat mb-8">
              {language === 'fr'
                ? "N'hésitez pas à nous contacter, nous serons ravis de vous répondre."
                : "Feel free to contact us, we'll be happy to answer."}
            </p>
            <a
              href="mailto:cyrilleneninbi@gmail.com"
              className="btn-primary inline-flex items-center space-x-2"
            >
              <Mail size={20} />
              <span>{language === 'fr' ? 'Nous contacter' : 'Contact Us'}</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
